import { ApplicationNewType, ApplicationType } from 'polly-commons';
import { ComponentGroup, ComputeApplicationData } from '../../interfaces';

/**
 * Extracts unique tags from a list of components.
 */
export function getUniqueTags(items: ComputeApplicationData[] = []): string[] {
  const dropdownLabels = new Set<string>();

  for (const item of items) {
    if (item && item.attributes && item.attributes.frontend_info && Array.isArray(item.attributes.frontend_info.tags)) {
      for (const tag of item.attributes.frontend_info.tags) {
        dropdownLabels.add(tag);
      }
    }
  }

  return Array.from(dropdownLabels);
}

/**
 * Converts a list of tags into tag group objects.
 */
export function getTagGroups(uniqueTags: string[]): ComponentGroup[] {
  const totalTagGroups: ComponentGroup[] = [{ label: 'All', value: '' }];

  uniqueTags.forEach((tag: string) => {
    totalTagGroups.push({
      label: tag.toLowerCase(),
      value: tag,
    });
  });

  return totalTagGroups;
}

/**
 * Filters components based on the name and excludes group = 'Discover'.
 */
export function filterComponentsByNameGroup(allComponents: ComputeApplicationData[], name: string): ComputeApplicationData[] {
  return allComponents.filter((component) => component.attributes.frontend_info.name.toLowerCase().includes(name.toLowerCase()));
}

/**
 * Filters components by the selected tag.
 */
export function filterComponentByTag(allComponents: ComputeApplicationData[], selectedTag: string): ComputeApplicationData[] {
  return allComponents.filter((component) => component.attributes.frontend_info.tags && component.attributes.frontend_info.tags.includes(selectedTag));
}

/**
 * Gets components of type WEB_APP.
 */
export function getWebAppComponents(allComponents: ComputeApplicationData[]): ComputeApplicationData[] {
  return allComponents.filter((component) => component.attributes.app_type === ApplicationNewType.WEB_APP);
}

/**
 * Gets components that are NOT of type WEB_APP.
 */
export function getFilteredComponents(allComponents: ComputeApplicationData[]): ComputeApplicationData[] {
  return allComponents.filter((component) => component.attributes.app_type !== ApplicationNewType.WEB_APP);
}

/**
 * Checks if the application is of type URL.
 */
export function isAppUrlType(application: ComputeApplicationData): boolean {
  return application.attributes.app_type === ApplicationType.URL;
}

/**
 * Checks if the application is of type Jupyter.
 */
export function isAppJupyterType(application: ComputeApplicationData): boolean {
  return application.attributes.app_type === ApplicationType.JUPYTER;
}

/**
 * Checks if the application is unlicensed.
 */
export function isUnlicensedApp(application: ComputeApplicationData): boolean {
  return !application.attributes.active || application.attributes.frontend_info.is_hidden_on_apps;
}